import { Injectable } from "@angular/core";
import { DwoMechanicTimeCodeResponseModel } from "../business-entities/dwo-mechanic-time-code-response.model";
import { GenericResponse } from '../business-entities/generic-response';
import { MechanicJobTimerRequestModel } from "../business-entities/mechanic-job-timer-request.model";
import { MechanicTimeCodeTimerRequestModel } from "../business-entities/mechanic-time-code-timer-request.model";
import { MechanicWorkOrderTimerRequestModel } from "../business-entities/mechanic-work-order-timer-request.model";
import { StampInOutRequestModel } from "../business-entities/stamp-in-out-request.model";
import { WorkOrderModel } from "../business-entities/work-order-model";
import { MechanicTimeStampDataService } from "../data-services/mechanic-time-stamp-data.service";


@Injectable({
    providedIn: 'root'
})

export class MechanicTimeStampService {
    constructor(private service: MechanicTimeStampDataService) {
    }



    GetSummaryDetails(id: number, date: Date): Promise<any> {
        return this.service.GetSummaryDetails(id,date);
    }

    GetMechanicTimeCodes(dealerId: string, langCode: string): Promise<GenericResponse<Array<DwoMechanicTimeCodeResponseModel>>> {
        return this.service.GetMechanicTimeCodes(dealerId, langCode);
    }

    MechanicStampIn(model: StampInOutRequestModel): Promise<GenericResponse<boolean>> {
        return this.service.MechanicStampIn(model);
    }
    MechanicStampOut(model: StampInOutRequestModel): Promise<GenericResponse<boolean>> {
        return this.service.MechanicStampOut(model);
    }

    StopTimeCodeTimer(model: MechanicTimeCodeTimerRequestModel): Promise<GenericResponse<boolean>> {
        return this.service.StopTimeCodeTimer(model);
    }

    StartTimeCodeTimer(model: MechanicTimeCodeTimerRequestModel): Promise<GenericResponse<boolean>> {
        return this.service.StartTimeCodeTimer(model);
    }

    GetTimeCodeDetails(mechanicId: number, date: Date): Promise<any> {
        return this.service.GetTimeCodeDetails(mechanicId, date);
    }

    GetMechanicStampInOutDetails(mechanicId: number, date: Date): Promise<any> {
        return this.service.GetMechanicStampInOutDetails(mechanicId, date);
    }

    UpdateMechanicStampOutDetails(model:any): Promise<any> {
        return this.service.UpdateMechanicStampOutDetails(model);
    }

    GetCurrentWO(mechanicId: number): Promise<any> {
        return this.service.GetCurrentWO(mechanicId);
    }

    GetJobsByWO(workOrderNo: string): Promise<any> {
        return this.service.GetJobsByWO(workOrderNo);
    }
    StopWorkOrderTimer(model: MechanicWorkOrderTimerRequestModel): Promise<GenericResponse<MechanicWorkOrderTimerRequestModel>> {
        return this.service.StopWorkOrderTimer(model);
    }
    CheckMechanicTimeDetails(model: any): Promise<any> {
        return this.service.CheckMechanicTimeDetails(model);
    }
    StartWorkOrderTimer(model: MechanicWorkOrderTimerRequestModel): Promise<GenericResponse<boolean>> {
        return this.service.StartWorkOrderTimer(model);
    }
    StopJobTimer(model: MechanicJobTimerRequestModel): Promise<GenericResponse<MechanicJobTimerRequestModel>> {
        return this.service.StopJobTimer(model);
    }
    StartJobTimer(model: MechanicJobTimerRequestModel): Promise<GenericResponse<boolean>> {
        return this.service.StartJobTimer(model);
    }
    GetWOSummary(mechanicId: number, workOderNo: string): Promise<any>{
        return this.service.GetWOSummary(mechanicId, workOderNo);
    }

    GetWorkOrders(dealerId:string) : Promise<GenericResponse<Array<WorkOrderModel>>>{
        return this.service.GetWorkOrders(dealerId);
    }

    GetWorkOrderDetails(mechanicId: number, workOderNo: string): Promise<any>{
        return this.service.GetWorkOrderDetails(mechanicId, workOderNo);
    }
    DeleteSummaryDetails(model:any): Promise<any>{
        return this.service.DeleteSummaryDetails(model);
    }
    EditSummaryDetails(model:any): Promise<any>{
        return this.service.EditSummaryDetails(model);
    }
    CheckTimerDetails(model:any): Promise<any>{
        return this.service.CheckTimerDetails(model);
    }
    EditClockingDetails(model:any): Promise<GenericResponse<number>>{
        return this.service.EditClockingDetails(model);
    }
    GetJobDetailByWO(jobId: number): Promise<any> {
        return this.service.GetJobDetailByWO(jobId);
    }
    StartJobDetailTimer(model: MechanicJobTimerRequestModel): Promise<GenericResponse<boolean>> {
        return this.service.StartJobDetailTimer(model);
    }
    StopJobDetailTimer(model: MechanicJobTimerRequestModel): Promise<GenericResponse<boolean>> {
        return this.service.StopJobDetailTimer(model);
    }
}